import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Field from 'component/utils/Field'
import Input from 'component/utils/Input'
import Form from 'component/utils/Form'
import Select from 'react-select/creatable'
import moment from 'moment'
import DatePicker from 'component/utils/DatePicker'
import { formatHour } from 'utils/masks'
import { options } from './options'
import CustomCompanySelect from 'component/branch/CustomCompanySelect'

class FilterForm extends Component {
  componentDidMount() {
    const { filters, setValueToField, translate, isNewFilter } = this.props
    if (filters.functionality && !isNewFilter) {
      const value = options.filter((o) => o.value === filters.functionality)[0]
      value.label = translate(value.label)
      setValueToField('functionality', value)
      setValueToField('listId', filters.listId)
      setValueToField('dtStart', filters.dtStart ? moment(filters.dtStart) : '')
      setValueToField('dtEnd', filters.dtEnd ? moment(filters.dtEnd) : '')
      setValueToField('hourStart', filters.hourStart)
      setValueToField('hourEnd', filters.hourEnd)
      setValueToField('idBranch', filters.idBranch)
    }
  }

  disableFilter = () => {
    const { fields } = this.props

    return !(
      (!!fields.dtStart.input.value &&
        !!fields.dtEnd.input.value &&
        !!fields.functionality.input.value.value) ||
      ((fields.functionality.input.value.value ===
        'pricebanner.preview.request' ||
        fields.functionality.input.value.value === 'pricebanner.request') &&
        !!fields.listId.input.value)
    )
  }

  handleSubmit = () => {
    const { fields, submit } = this.props

    const params = {
      functionality: fields.functionality.input.value.value,
      dtStart: fields.dtStart.input.value._d
        ? fields.dtStart.input.value._d
        : '',
      dtEnd: fields.dtEnd.input.value._d ? fields.dtEnd.input.value._d : '',
      hourStart: fields.hourStart.input.value,
      hourEnd: fields.hourEnd.input.value,
      listId: fields.listId.input.value,
      idBranch: fields.idBranch.input.value,
    }

    submit(params)
  }

  setHour = (field, value) => {
    const { setValueToField } = this.props
    setValueToField(field, formatHour(value))
  }

  setBranchInfo = (option) => {
    const { setValueToField } = this.props
    setValueToField('idBranch', option.value)
  }

  renderOptions = () =>
    options.map((option) => ({
      value: option.value,
      label: this.props.translate(option.label),
    }))

  render() {
    const {
      fields,
      translate,
      setValueToField,
      values,
      classFilter,
      classTitle,
      user,
    } = this.props

    return (
      <div className={classFilter || 'log-filter-form'}>
        <Row>
          {classTitle ? (
            <span className='query-log-label query-log-test'>
              {translate('queryLogs.table.title')}
            </span>
          ) : (
            <Col className={'log-form-title'}>
              <h3>{translate('query.logs')}</h3>
            </Col>
          )}
        </Row>
        <Row>
          <Col>
            <Field
              {...fields.functionality}
              hint={translate('query.logs.functionality')}
            >
              <Select
                className='react-select'
                classNamePrefix='react-select'
                formatCreateLabel={(string) =>
                  `${translate('query.logs.functionality')} ${string}`
                }
                id='functionality'
                menuPortalTarget={document.body}
                name='functionality'
                onChange={(option) => setValueToField('functionality', option)}
                options={this.renderOptions()}
                placeholder=''
                isClearable='true'
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                value={values.functionality}
              />
            </Field>
          </Col>
        </Row>
        <Row>
          <Col>
            <Field
              {...fields.idBranch}
              hint={translate('ruptures.idBranch')}
              error={translate(fields.idBranch.error)}
            >
              <CustomCompanySelect
                {...fields.idBranch.input}
                onChange={this.setBranchInfo}
                token={user.dsToken}
                translate={translate}
              />
            </Field>
          </Col>
        </Row>
        <Row>
          <Col>
            <Field {...fields.listId} hint={translate('query.logs.listId')}>
              <Input
                id='listId'
                {...fields.listId.input}
                onChange={(option) =>
                  setValueToField('listId', option.target.value)
                }
              />
            </Field>
          </Col>
        </Row>
        <Row className='margin-top margin-bottom'>
          <Col>
            <Field
              {...fields.dtStart}
              glyph='glyph glyph-calendar'
              hint={translate('query.logs.dtStart')}
            >
              <DatePicker
                {...fields.dtStart.input}
                placeholder={translate('query.logs.placeholder.start')}
                isOutsideRange={(date) =>
                  moment(date).isAfter(fields.dtEnd.input.value)
                }
                scrollIntoView={false}
                openUp='up'
              />
            </Field>
          </Col>
        </Row>
        <Row className='margin-top margin-bottom'>
          <Col>
            <Field
              {...fields.dtEnd}
              glyph='glyph glyph-calendar'
              hint={translate('query.logs.dtEnd')}
            >
              <DatePicker
                {...fields.dtEnd.input}
                placeholder={translate('query.logs.placeholder.end')}
                isOutsideRange={(date) =>
                  moment(date).isBefore(fields.dtStart.input.value)
                }
                scrollIntoView={false}
                openUp='up'
              />
            </Field>
          </Col>
        </Row>
        <div
          style={{ display: 'inline-flex', width: '103%', marginLeft: '-1%' }}
        >
          <Col style={{ width: '100%' }}>
            <Field
              glyph='glyph glyph-clock'
              {...fields.hourStart}
              hint={translate('query.logs.hourStart')}
            >
              <Input
                {...fields.hourStart.input}
                id='hourStart'
                maxLength={5}
                onChange={(option) =>
                  this.setHour('hourStart', option.target.value)
                }
              />
            </Field>
          </Col>
          <Col style={{ width: '100%', marginLeft: '5%' }}>
            <Field
              glyph='glyph glyph-clock'
              {...fields.hourEnd}
              hint={translate('query.logs.hourEnd')}
            >
              <Input
                {...fields.hourEnd.input}
                id='hourEnd'
                maxLength={5}
                onChange={(option) =>
                  this.setHour('hourEnd', option.target.value)
                }
              />
            </Field>
          </Col>
        </div>

        <button
          onClick={this.handleSubmit}
          className='button button-primary button-full'
          style={{ width: '103%', marginLeft: '-1%', marginTop: '40px' }}
          disabled={this.disableFilter()}
        >
          {translate('filter_button_label')}
        </button>
      </div>
    )
  }
}
const fields = [
  'functionality',
  'listId',
  'dtStart',
  'dtEnd',
  'hourStart',
  'hourEnd',
  'idBranch',
]

export default Form({ fields })(FilterForm)
export { FilterForm }

FilterForm.propTypes = {
  translate: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  setValueToField: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  classFilter: PropTypes.string,
  classTitle: PropTypes.bool,
  filters: PropTypes.object,
  isNewFilter: PropTypes.bool,
  user: PropTypes.object.isRequired,
}
